import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import MUIAlert, { AlertProps as MUIAlertProps } from "@mui/material/Alert";
import MUIAlertTitle from "@mui/material/AlertTitle";
import {
  faDiamondExclamation,
  faFlag,
  faInfoCircle,
  faPartyHorn,
  faTimes,
} from "@outschool/icons";
import * as React from "react";

import Icon from "../Icon/Icon";

export const AlertSeverities = ["success", "info", "warning", "error"] as const;
export type AlertSeverity = typeof AlertSeverities[number];

export type AlertProps = Omit<
  MUIAlertProps,
  "color" | "variant" | "severity"
> & {
  title?: string;
  severity?: AlertSeverity;
};

const SEVERITY_ICONS = {
  error: <Icon icon={faDiamondExclamation} size="medium" />,
  warning: <Icon icon={faFlag} size="medium" />,
  info: <Icon icon={faInfoCircle} size="medium" />,
  success: <Icon icon={faPartyHorn} size="medium" />,
};

function Alert(
  {
    title,
    severity = "error",
    action,
    onClose,
    children,
    ...props
  }: AlertProps,
  ref: React.Ref<any>
) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <MUIAlert
      ref={ref}
      iconMapping={SEVERITY_ICONS}
      severity={severity}
      action={
        <>
          {!isMobile && action}
          {onClose && (
            <IconButton
              onClick={onClose}
              sx={{ padding: "12px", color: theme.palette.text.primary }}
            >
              <Icon icon={faTimes} size="medium" />
            </IconButton>
          )}
        </>
      }
      {...props}
    >
      {title && <MUIAlertTitle>{title}</MUIAlertTitle>}
      {children}
      {isMobile && action}
    </MUIAlert>
  );
}

export default React.forwardRef(Alert);
